var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define('tracks/start-slices',["require", "exports", "../tracks/track-enabled", "../util/convert"], function (require, exports, trackEnabled, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.startSlices = void 0;
    var metricSlices = [20, 50, 100, 200, 300, 400];
    var freedomSlices = [50, 100, 200, 300, 600, 900];
    var altitudes = convert_1.default.system === "metric" ? metricSlices : freedomSlices;
    /**
     * Return HTML summary of horizontal slices of the start arcs for all enabled tracks.
     * TODO: Metric vs imperial
     */
    function startSlices() {
        return __awaiter(this, void 0, void 0, function () {
            var slices, summary, _i, altitudes_1, alt, range;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSlices()];
                    case 1:
                        slices = _a.sent();
                        summary = "";
                        for (_i = 0, altitudes_1 = altitudes; _i < altitudes_1.length; _i++) {
                            alt = altitudes_1[_i];
                            range = slices[alt];
                            if (range) {
                                summary += "<div>" + -alt + convert_1.default.distance.label + ": " + range.min.toFixed(0) + " ... " + range.max.toFixed(0) + " " + convert_1.default.distance.label + "</div>";
                            }
                            else {
                                summary += "<div>" + -alt + convert_1.default.distance.label + ":";
                            }
                        }
                        return [2 /*return*/, summary];
                }
            });
        });
    }
    exports.startSlices = startSlices;
    function getSlices() {
        return __awaiter(this, void 0, void 0, function () {
            var tracks, trackIds, slices, _i, trackIds_1, trackId, track, _a, altitudes_2, alt, x, range;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tracks = trackEnabled.pending;
                        trackIds = Object.keys(tracks);
                        if (!(trackIds.length > 0)) return [3 /*break*/, 5];
                        slices = {};
                        _i = 0, trackIds_1 = trackIds;
                        _b.label = 1;
                    case 1:
                        if (!(_i < trackIds_1.length)) return [3 /*break*/, 4];
                        trackId = trackIds_1[_i];
                        return [4 /*yield*/, tracks[trackId]
                            // Expand ranges
                        ];
                    case 2:
                        track = _b.sent();
                        // Expand ranges
                        for (_a = 0, altitudes_2 = altitudes; _a < altitudes_2.length; _a++) {
                            alt = altitudes_2[_a];
                            x = xForY(track, -alt);
                            if (x !== undefined) {
                                range = slices[alt];
                                if (!range) {
                                    slices[alt] = { min: x, max: x };
                                }
                                else if (x < range.min) {
                                    range.min = x;
                                }
                                else if (x > range.max) {
                                    range.max = x;
                                }
                            }
                        }
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, slices];
                    case 5: throw new Error("no tracks");
                }
            });
        });
    }
    /**
     * Find horizontal x distance for given y altitude
     * TODO: interpolate between points
     */
    function xForY(track, y) {
        // Find first point below given y
        var index = track.data.findIndex(function (p) { return p.y < y; });
        if (index >= 0) {
            return track.data[index].x;
        }
        else {
            return undefined;
        }
    }
});
//# sourceMappingURL=/assets/javascripts/tracks/start-slices.js.map;
